import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import hubapi from 'hub-http/stacks/hubapi';
import { checkNetworkOnTimeout } from '../middlewares/checkNetworkOnTimeout';
import { checkExpiredCookie } from '../middlewares/checkExpiredCookie';
const stack = createStack(hubapi, checkNetworkOnTimeout(), checkExpiredCookie);
const http = promiseClient(stack);
export default http;